
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import * as n from "@/types/notifications";
import EmailForHost from "@/components/Notifications/Types/Util/EmailForHost.vue";
import ErrorNextSteps from "@/components/Notifications/Types/Util/ErrorNextSteps.vue";
import InternalServerErrorErrorDetails from "@/components/Notifications/Types/Util/InternalServerErrorErrorDetails.vue";
import InternalServerErrorRequestDetails from "@/components/Notifications/Types/Util/InternalServerErrorRequestDetails.vue";

@Component({
  components: {
    ErrorNextSteps,
    EmailForHost,
    InternalServerErrorErrorDetails,
    InternalServerErrorRequestDetails
  }
})
export default class FriendlyMultiError extends Vue {
  @Prop()
  value!: n.InternalServerErrorNotification | n.ForbiddenErrorNotification;

  tab = 0;

  detailsDialogOpen = false;

  toggleDetailsDialog() {
    this.detailsDialogOpen = !this.detailsDialogOpen;
  }

  closeDialog() {
    this.detailsDialogOpen = false;
  }
}
